import AlgoliaSearch, { SearchIndex } from 'algoliasearch';
import { ActivationStatusService } from './activation-status.service';
import { TeamSettingsService } from './team-settings.service';

declare const __ALGOLIA_CONFIG__: {
  appId: string;
  docsAPIKey: string;
  dashboardAPIKey: string;
};

export let _algoliaService: AlgoliaService;

export class AlgoliaService {
  static deps = [TeamSettingsService, ActivationStatusService];

  private docIndex: SearchIndex;

  private productRoutesSearchIndex: SearchIndex;

  constructor(
    private _teamSettingsService: TeamSettingsService,
    private _activationStatusService: ActivationStatusService
  ) {
    _algoliaService = this;

    const DocsAlgoliaSearchClient = AlgoliaSearch(__ALGOLIA_CONFIG__.appId, __ALGOLIA_CONFIG__.docsAPIKey);
    this.docIndex = DocsAlgoliaSearchClient.initIndex('hevo-docs');

    const ProductAlgoliaSearchClient = AlgoliaSearch(
      __ALGOLIA_CONFIG__.appId,
      __ALGOLIA_CONFIG__.dashboardAPIKey
    );

    this.productRoutesSearchIndex = ProductAlgoliaSearchClient.initIndex('hevo-product-routes-test');
  }

  queryProductRoutes(search: string) {
    if (!search) {
      return Promise.resolve([]);
    }

    const isWorkflowEnabled = this._teamSettingsService.isWorkflowsEnabled();
    const isActivationEnabled = this._activationStatusService.shouldShowActivation();

    return this.productRoutesSearchIndex.search(search).then((productRoutesResult) => {
      let routes = productRoutesResult.hits.map((hit: any) =>
        this.searchResultFactory(hit, 'product')
      );

      if (!isWorkflowEnabled) {
        routes = routes.filter((item) => item.icon !== 'workflow');
      }

      if (!isActivationEnabled) {
        routes = routes.filter((item) => item.icon !== 'activate');
      }

      return routes;
    });
  }

  queryDocs(search: string, pageLimit = 10) {
    if (!search) {
      return Promise.resolve([]);
    }

    const isH20Enabled = this._teamSettingsService.isH2OEnabled();

    const facetFilters = [];

    if (!isH20Enabled) {
      facetFilters.push('categories:docs-standard');
    }

    return this.docIndex.search(
      search,
      {
        hitsPerPage: pageLimit,
        facets: ['categories'],
        facetFilters: facetFilters
      })
      .then((docResult) =>
      docResult.hits.map((hit) => this.searchResultFactory(hit, 'docs'))
    );
  }

  private searchResultFactory(hit, category: 'product' | 'docs') {
    const id = hit.objectID;
    const title = this.getParsedHTMLContent(hit.title);
    const { url } = hit;
    const icon = hit?.icon || 'documentation';

    return {
      id,
      title,
      url,
      icon,
      category,
    };
  }

  private getParsedHTMLContent(text: string) {
    const parser = new DOMParser();
    return parser.parseFromString(text, 'text/html').body.textContent;
  }
}
